import { GuardianDnoNumberTypes } from 'RtModels';

export const DoNotOriginateNumberTypeToNameMap = new Map<
	GuardianDnoNumberTypes,
	string
>([
	[GuardianDnoNumberTypes.Dno, 'Do Not Originate'],
	[GuardianDnoNumberTypes.WhiteList, 'White List']
]);
